import { AppDispatch } from '../store';
import { saveDraft, updateDraft, deleteDraft, clearAllDrafts, setDrafts, PostDraft } from '../store/slices/DraftSlice';

// Redux-based draft utility functions
export const draftUtils = {
  saveDraft: (dispatch: AppDispatch, draftData: Omit<PostDraft, 'id' | 'createdAt' | 'updatedAt'>) => {
    dispatch(saveDraft(draftData));
  },

  updateDraft: (dispatch: AppDispatch, id: string, updatedDraft: Partial<PostDraft>) => {
    dispatch(updateDraft({ id, draft: updatedDraft }));
  },

  deleteDraft: (dispatch: AppDispatch, id: string) => {
    dispatch(deleteDraft(id));
  },

  clearAllDrafts: (dispatch: AppDispatch) => {
    dispatch(clearAllDrafts());
  },

  setDrafts: (dispatch: AppDispatch, drafts: PostDraft[]) => {
    dispatch(setDrafts(drafts));
  },
};

// Re-export the PostDraft type for convenience
export type { PostDraft };